export default __webpack_public_path__ + "static/media/boston.778e707a.png";